import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { CoreLogService } from "../services/log.service";
import { SortDirection } from "../shared/contentTypes";
import { MenugroupService } from "../components/menugroup/menugroup.service";
import { ItemGroupMenuViewModel } from "../shared/models";
import { PagingHelper } from "../shared/pagingHelper";
import { SortOption } from "../shared/models/sort.model";

@Injectable({
  providedIn: "root"
})
export class ItemGroupMenuResolver implements Resolve<ItemGroupMenuViewModel[]> {

  private pagingHelper: PagingHelper = new PagingHelper();
  private sortOption: SortOption[] = [];
  constructor(private _coreLogService: CoreLogService
    , private _menugroupService: MenugroupService) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<ItemGroupMenuViewModel[]> {
    const me = this;
    return new Promise<ItemGroupMenuViewModel[]>(async (resolve, reject) => {
      try {
        const validItemGroups: ItemGroupMenuViewModel[] = await me._menugroupService.GetValideItemMenuGroup();
        me.sortOption.push(me.pagingHelper.createSortOption("sort_nr", SortDirection.ASC));
        validItemGroups.sort(me.pagingHelper.fieldSorter(me.sortOption));
        resolve(validItemGroups);
      } catch (error) {
        me._coreLogService.error("ItemGroupMenuResolver.resolve", "GetValideItemMenuGroup", error);
        resolve(null);
      }
    });
  }
}
